import {
  getDraftingHistoryApi,
  deleteDraftingHistoryApi,
  updateDraftingHistoryFlagsApi,
  updateDraftingHistoryDocumentApi,
} from "../services/api/draftingHistoryApi";

export const editContractTitle =
  (userId, chatId, newTitle) => async (dispatch, getState) => {
    try {
      const state = getState();
      const record = state.contractTitles.titles?.find(
        (title) => title.chat_id === chatId
      );
      if (!record?._id) {
        console.log("Contract record not found for title edit");
        return;
      }

      const response = await updateDraftingHistoryDocumentApi("contract", {
        _id: record._id,
        user_id: userId,
        Document: record.Document,
        Title: newTitle,
        form_metadata: record.form_metadata,
      });
      if (response.status === 200) {
        const responseData = response.data;
        console.log(responseData);
        dispatch({
          type: "EDIT_CONTRACT_TITLE",
          payload: { chatId, newTitle },
        });
      } else {
        console.log("Title not found");
      }
    } catch (error) {
      console.log(error.response?.data?.message ?? error.message);
    }
  };

export const deleteContract =
  (userId, chatId) => async (dispatch, getState) => {
    try {
      const state = getState();
      const record = state.contractTitles.titles?.find(
        (title) => title.chat_id === chatId
      );
      if (!record?._id) {
        console.log("Contract record not found for deletion");
        return;
      }

      const response = await deleteDraftingHistoryApi("contract", {
        _id: record._id,
        user_id: userId,
      });
      if (response.status === 200) {
        dispatch({
          type: "DELETE_CONTRACT_TITLE",
          payload: { chatId },
        });
        console.log("Chat deleted");
      } else {
        console.log("Chat not found");
      }
    } catch (error) {
      console.log(error.response?.data?.message ?? error.message);
    }
  };

export const toggleContractPin =
  (userId, chatId, isPinned) => async (dispatch, getState) => {
    try {
      const state = getState();
      const record = state.contractTitles.titles?.find(
        (title) => title.chat_id === chatId
      );
      if (!record?._id) {
        console.log("Contract record not found for pin update");
        return;
      }

      const response = await updateDraftingHistoryFlagsApi("contract", {
        _id: record._id,
        user_id: userId,
        isPinned,
      });
      if (response.status === 200) {
        dispatch({
          type: "TOGGLE_PIN_CONTRACT",
          payload: { chatId, isPinned },
        });
      }
    } catch (error) {
      console.log(error.response?.data?.message ?? error.message);
    }
  };

export const getContractTitles = (type, userId) => async (dispatch, getState) => {
  const state = getState();
  try {
    if (state.contractTitles.titles?.length === 0) {
      dispatch({
        type: "GET_CONTRACT_TITLES_REQUEST",
      });
    }

    const response = await getDraftingHistoryApi(type, userId);
    if (response.status === 200) {
      const responseData = response.data;
      dispatch({
        type: "GET_CONTRACT_TITLES_SUCCESS",
        payload: responseData,
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_CONTRACT_TITLES_FAIL",
      payload:
        "Contract history could not be fetched at this moment. Please try again later.",
    });
  }
};
